import {createReducer, on} from '@ngrx/store';
import {ExportConfigEntitiesActions} from '../actions/export-config-entities.actions';
import {
  exportConfigEntitiesAdapter,
  exportConfigEntitiesInitialState as initialState
} from '../states/export-config-entities.state';


export const exportConfigEntitiesInitialState = initialState;

export const exportConfigEntitiesReducer = createReducer(
  exportConfigEntitiesInitialState,

  on(ExportConfigEntitiesActions.loadExportConfigsSuccess, (state, {exportConfigs}) => {
    return exportConfigEntitiesAdapter.upsertMany(exportConfigs, {
      ...state,
      loaded: true,
    });
  }),

  on(ExportConfigEntitiesActions.loadExportConfigsFailure, (state) => {
    return {
      ...state,
      loaded: true,
    };
  }),
);
